module.exports = __webpack_public_path__ + "static/media/control_logo.04c025e7.jpg";